import React from 'react';
import { Clock, Target, Zap, TrendingUp } from 'lucide-react';

const AboutSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Por que <span className="text-orange-500">Direito em 5 Minutos?</span>
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Sabemos que o tempo é o bem mais precioso de quem estuda para concursos. 
            Por isso, criamos uma metodologia que une praticidade, objetividade e eficiência. 
            Nossos flashcards são elaborados para maximizar sua retenção de conteúdo em menos tempo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          <div className="group bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="bg-blue-900 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <Clock className="text-orange-400" size={32} />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Praticidade
            </h3>
            <p className="text-gray-700">
              Estude em qualquer lugar, a qualquer hora. Conteúdo direto e objetivo.
            </p>
          </div>

          <div className="group bg-gradient-to-br from-orange-50 to-orange-100 p-8 rounded-2xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="bg-orange-500 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <Zap className="text-white" size={32} />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Objetividade
            </h3>
            <p className="text-gray-700">
              Sem enrolação. Apenas o que realmente importa para sua aprovação.
            </p>
          </div>

          <div className="group bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="bg-blue-900 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <Target className="text-orange-400" size={32} />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Eficiência
            </h3>
            <p className="text-gray-700">
              Método de revisão ativa comprovado pela ciência da aprendizagem.
            </p>
          </div>

          <div className="group bg-gradient-to-br from-orange-50 to-orange-100 p-8 rounded-2xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="bg-orange-500 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <TrendingUp className="text-white" size={32} />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              Resultados
            </h3>
            <p className="text-gray-700">
              Milhares de alunos aprovados estudando com nossa metodologia.
            </p>
          </div>
        </div>

        <div className="mt-16 max-w-4xl mx-auto bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 md:p-12 text-white shadow-2xl">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <h3 className="text-3xl font-bold mb-4">
                Simplifique o Direito. Acelere sua aprovação.
              </h3>
              <p className="text-lg text-gray-200">
                Nossa missão é ser o aliado definitivo do concurseiro, oferecendo conteúdo 
                de qualidade que realmente faz a diferença na hora da prova.
              </p>
            </div>
            <div className="flex-shrink-0">
              <div className="bg-orange-500 text-white px-8 py-4 rounded-full font-bold text-xl shadow-lg animate-pulse">
                + de 1.000 aprovados
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
